<template>
  <section class="section">
      <div class="container">
          <div class="col-12">
              <div class="subheadline">
                  <p v-html="HtmlEncode(subheadline)"></p>
              </div>
          </div>
          <div class="col-12">
              <filter-sidebar v-bind:filters="filters"
                              v-bind:title="title"></filter-sidebar>
          </div>

          <div class="col-12" v-if="listing.length">
              <div class="related-recipes-container">
                  <summary-item v-for="(item, index) in listing"
                                v-bind:item="item"
                                v-bind:key="item.Id"></summary-item>
              </div>

              <pagination></pagination>
          </div>

          <div class="cards-no-results col-lg-9" v-if="listing.length < 1">
              <h2>No Results</h2>
              <p>
                  Sorry, there are no results matching your Sort and Filter criteria.
              </p>
              <a href="#" v-on:click.prevent="resetFilters">Clear Sort and Filters</a>
          </div>
      </div>
  </section>
</template>

<script>
import SmoothScroll from 'smooth-scroll';
import { mapState, mapActions, mapMutations } from 'vuex';
import Pagination from '../components/listing/pagination-dropdown';
import SummaryItem from '../components/listing/recipe-summary-item';
import FilterSidebar from '../components/listing/filter-sidebar';
import recipefilter from '../filters/recipe-filter';

export default {
  props: ['filterid', 'filtertype', 'result', 'resource', 'title', 'subheadline', 'enablemealtype'],
  data: function() {
    return {
      filters: {},
    };
  },
  computed: mapState({
    loading: (state) => state.listing.loading,
    listing: (state) => state.listing.listing,
    pagination: (state) => state.listing.pagination,
  }),
  components: {
    pagination: Pagination,
    'summary-item': SummaryItem,
    'filter-sidebar': FilterSidebar,
  },
  mounted: function() {
    let _this = this;

    // take props and send to vuex store
    this.setInitData(this.result);
    this.setResource(this.resource);

    // import correct filters for this view based on prop value
    if (this.filtertype === 'recipefilter') {
    if(this.enablemealtype === 'False') {
      delete recipefilter['MealTypes'];
    }
      this.filters = recipefilter;
    }

    // after filter comes back, scroll to the top
    let scroll = new SmoothScroll();
    let options = {
      header: '[data-scroll-header]',
      speed: 1000,
      offset: $("#filter-app").offset().top || 96,
    };

    // after any api calls, scroll to the top of the list
    this.$store.subscribeAction((action, state) => {
      if (action.type === 'listing/setFilter') {
        let top = ($("#filter-app").offset().top - 80) || 0;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });

    // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'listing/updateSpecification') {
        this.setFilter();
      }
    });
  },
  methods: {
    ...mapActions('listing', { setFilter: 'setFilter' }),
    ...mapMutations('listing', { setInitData: 'setInitData' }),
    ...mapMutations('listing', { setResource: 'setResource' }),
    ...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
    stripHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      let text = doc.body.textContent || "";

      return text.replace(/^"+|"+$/g, "");
    },
    HtmlEncode(html) {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = html;
      let decoded = textarea.value;
      decoded = decoded.replace(/^"|"$/g, "");
      decoded = decoded.replace(/href=(['"])~\//g, 'href=$1/');
      return decoded;
    },
    resetFilters(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      this.resetSpecification();
      window.location.reload();
    },
  },
};
</script>
